import { FetchDocumentRequest } from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useFetchDocument() {
  const source = axios.CancelToken.source();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const fetchDocument = async (request: FetchDocumentRequest) => {
    try {
      const res = await api.fetchDocument(request, undefined, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (err) {
      console.error(err);

      throw err;
    }
  };

  return {
    fetchDocument,
  };
}
